import { View, Model } from "@lernetz/ts-lib";
import { ViewConfig } from '@lernetz/ts-lib/src/view/View';

const defaultStyles = {
    'h1': 'text-style -h1',
    'h2': 'text-style -h2',
    'h3': 'text-style -h3',
    'h4': 'text-style -h4',
    'h5': 'text-style -h5',
    'h6': 'text-style -h6',
};

export class Heading extends Model {
    html: string;
    level: 1 | 2 | 3 | 4 | 5 | 6;
    readonly styles?: { [ tagName:string ]:string };
}

export class HeadingView extends View<Heading> {

    private readonly _styles: { [tagName:string ]:string };

    public constructor( config?:ViewConfig<Heading> ) {
        super( { data:new Heading(), ...config } );
    }

    public init() {
        this.update();
    }

    public update() {
        if( this.data ) {
            const { level, html } = this.data;
            let validatedLevel = Number( level ) || 6;
            if( validatedLevel < 1 || 6 < validatedLevel) validatedLevel = 6;
            this.node.innerHTML = `<h${validatedLevel}>${html}</h${validatedLevel}>`;
        }
        else {
            this.node.innerHTML = '';
        }

        this.applyStyles();
    }

    applyStyles() {
        const walker = document.createTreeWalker( this.node, NodeFilter.SHOW_ELEMENT );
        const styles = this?.data?.styles ?? defaultStyles;
        while( walker.nextNode() ) {
            const key = walker.currentNode.nodeName.toLowerCase();
            if( key in styles ) {
                const element = walker.currentNode as Element;
                element.classList.add.apply( element.classList, styles[ key ].split( ' ' ) );
            }
        }
    }
}
